import React from "react";
import ReactDOM from "react-dom";
import App from "components/App";
import * as serviceWorker from "serviceWorker";
import ReactGA from 'react-ga';
// import "./styles/global.scss";

// if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-144253068-1');
// }

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
